import { useContext, useEffect } from 'react';
import { GlobalContext } from '../context/GlobalState';
import Box from './Box';
import { closeOverlay } from '../functions';

const DeliveryOptions = props => {
	const [ state, dispatch ] = useContext( GlobalContext );

	useEffect( function() {
		dispatch( {
			type: 'SET_OVERLAY_VISIBILITY',
			payload: props.overlayOpened,
		} );
	}, [ props.overlayOpened ] );

	useEffect( function() {
		displaySavedData();
	}, [] );

	const displaySavedData = () => {
		let { selectedDistributionMethod, selectedEmails } = props;
		selectedEmails = JSON.parse( selectedEmails || '' );
		if ( '' !== selectedDistributionMethod ) {
			dispatch( {
				type: 'SET_STEP',
				payload: 'savedData',
			} );
			dispatch( {
				type: 'SET_SAVED_DISTRIBUTION_METHOD',
				payload: selectedDistributionMethod,
			} );
			dispatch( {
				type: 'SET_EMAILS',
				payload: [ ...selectedEmails ],
			} );
		}
	};

	const onChooseBtnClick = e => {
		e.preventDefault();
		dispatch( {
			type: 'SET_OVERLAY_VISIBILITY',
			payload: true,
		} );
	};

	document.getElementById( `react-digital-code-delivery-options-btn-${ props.cartItemKey }` ).addEventListener( 'click', onChooseBtnClick );

	return (
		<div id={ `digital-code-overlay-${ props.cartItemKey }` }>
			{ state.isOverlayVisible && (
				<div className="digital-code-overlay" style={ { display: 'flex' } }>
					<div className="content">
						<div className="header">
							<span className="close" onClick={ () => { // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
								closeOverlay( dispatch, state );
							} }>x</span>
						</div>
						<Box { ...props } />
					</div>
				</div>
			) }
		</div>
	);
};

export default DeliveryOptions;
